import React from 'react';

function Desktop(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M5.12668 3.00391H18.8767C20.6027 3.00391 22.0017 4.40289 22.0017 6.12891V12.875C22.0017 14.601 20.6027 16 18.8767 16H12.6267V17.2681C15.4039 17.4297 17.625 18.6587 17.625 20.375C17.625 20.7202 17.3452 21 17 21H7.00001C6.65483 21 6.37501 20.7202 6.37501 20.375C6.37501 18.658 8.59795 17.4287 11.3767 17.2679V16H5.12668C3.40067 16 2.00168 14.601 2.00168 12.875V6.12891C2.00168 4.40289 3.40067 3.00391 5.12668 3.00391ZM12.0017 14.75H18.8767C19.9123 14.75 20.7517 13.9107 20.7517 12.875V6.12891C20.7517 5.09325 19.9123 4.25391 18.8767 4.25391H5.12668C4.09102 4.25391 3.25168 5.09325 3.25168 6.12891V12.875C3.25168 13.9107 4.09102 14.75 5.12668 14.75H12.0017ZM12.0017 18.5H12C10.1138 18.5 8.54827 19.0627 7.92036 19.7388L7.91001 19.75H16.089L16.0797 19.7388C15.4791 19.0921 14.0205 18.5491 12.2442 18.5032L12.0017 18.5Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Desktop;
